<template>
  <el-card style="height: 100%" class="box-card">
    <div slot="header" class="clearfix">
      <!-- 标题 -->
      <el-row>
        <el-col :span="15">
          <span style="font-size: 24px">审核资料</span>
          <div class="head-text" style="float: right; margin-top: 0px">
            <!-- 新建事件 -->
            <el-input
              v-model="query"
              placeholder="请输入文件名称关键词"
              class="search-input"
              style="width: 300px"
            ></el-input>
            <el-button
              @click="getDataFileList"
              slot="append"
              icon="el-icon-search"
              style="margin-right: 40px"
            ></el-button>
          </div>
        </el-col>
        <el-col :span="9">
          <el-row>
            <el-col :span="4">
              <el-select
                filterable
                v-model="aaa.type"
                placeholder="请选择"
                @change="selectChange"
              >
                <el-option
                  v-for="item in typeOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-col>
            <el-col :span="4" :offset="1">
              <el-button
                @click="FileBatchAudit(1, 'more')"
                style="width: 100%"
                type="primary"
                >批量通过</el-button
              >
            </el-col>
            <el-col :span="4" :offset="1">
              <el-button
                @click="rejectFileFlowOpen('more')"
                style="width: 100%"
                type="danger"
                >批量驳回</el-button
              >
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </div>
    <el-container>
      <el-aside
        width="200px"
        style="
          border: 1px solid #dcdfe6;
          border-radius: 4px;
          height: 100%;
          text-align: center;
        "
        class="elAside"
      >
        <el-button type="primary" size="small" @click="showAll"
          >显示全部文档</el-button
        >
        <div class="zTreeDiv">
          <ul id="ProjectFileTree" class="ztree"></ul>
        </div>
      </el-aside>
      <el-main>
        <div class="rygl-table">
          <el-table
            ref="multipleTable"
            :data="fileTableData"
            tooltip-effect="dark"
            style="width: 100%"
            height="72vh"
            @selection-change="fileFlowhandleSelectionChange"
            v-loading="tableLoading"
          >
            <el-table-column
              :selectable="checkboxT"
              align="center"
              type="selection"
              width="55"
            ></el-table-column>
            <el-table-column
              align="center"
              type="index"
              label="序号"
            ></el-table-column>
            <el-table-column
              align="center"
              width="200px"
              prop="name"
              label="文件名称"
              sortable
            >
              <template slot-scope="scope">
                <a
                  v-if="exts.indexOf(scope.row.ext) > -1"
                  target="_blank"
                  @click="documentOpen(scope.row)"
                >
                  <el-button style="width: 100%" :title="scope.row.prfl02">{{
                    scope.row.prfl02.length > 10
                      ? scope.row.prfl02.substr(0, 10) + "..."
                      : scope.row.prfl02
                  }}</el-button>
                </a>
                <span v-else>{{ scope.row.prfl02 }}</span>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              prop="prfl09"
              label="大小（MB）"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="user04"
              label="上传用户"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="prfl12"
              label="上传时间"
            ></el-table-column>
            <el-table-column align="center" prop="prfl13" label="状态">
              <template slot-scope="scope">
                <span>{{
                  scope.row.isNeedAudit == 0 ? "审核中" : "待审核"
                }}</span>
              </template>
            </el-table-column>
            <el-table-column
              align="center"
              prop="name"
              label="操作"
              width="280"
            >
              <template slot-scope="scope">
                <el-button
                  @click="FileBatchAudit(1, 'single', scope.row)"
                  v-if="scope.row.isNeedAudit == 1"
                  type="primary"
                  size="mini"
                  >通过</el-button
                ><el-button
                  v-if="scope.row.isNeedAudit == 1"
                  type="danger"
                  size="mini"
                  @click="rejectFileFlowOpen('single', scope.row)"
                  >驳回</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <el-pagination
          style="margin-top: 20px"
          align="center"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagenum"
          :page-sizes="[10, 50, 100]"
          :page-size="pagesize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </el-main>
    </el-container>
    <!-- 资料预览 -->
    <el-dialog
      :close-on-click-modal="false"
      title="资料预览"
      width="40%"
      :visible.sync="documentIsShow"
    >
      <div>
        <iframe
          width="100%"
          height="500px"
          :src="iframeUrl"
          frameborder="0"
        ></iframe>
      </div>
    </el-dialog>
    <!-- 驳回 -->
    <el-dialog
      :close-on-click-modal="false"
      title="驳回详情"
      width="30%"
      :visible.sync="rejectFileFlow"
    >
      <div style="text-align: right">
        <el-input
          type="textarea"
          :rows="2"
          placeholder="请输入内容"
          v-model="content"
        >
        </el-input>
        <el-button
          style="margin: 20px"
          @click="FileBatchAudit(0, 'more')"
          type="primary"
          size="mini"
          >驳回</el-button
        >
      </div>
    </el-dialog>
  </el-card>
</template>

<script>
import dataManagement from "@/mixin/dataManagement";
import * as tools from "@/tools/tool";
import _ from "lodash";
import {
  GetProjectFileZTree,
  GetMyAuditFile,
  FileBatchAudit,
  Office2Pdf,
} from "@/setAxios.js";
export default {
  name: "dataList",
  mixins: [dataManagement],
  data() {
    return {
      exts: [
        "png",
        "jpg",
        "mp4",
        "docx",
        "doc",
        "xlsx",
        "xls",
        "ppt",
        "pptx",
        "js",
        "txt",
        "gif",
        "pdf",
      ],
      fileMultipleSelection: [],
      query: "",
      pagesize: 10,
      pagenum: 1,
      total: 0,
      TreeData: [],
      fileTableData: [],
      fileTableData2: [],
      tableLoading: false,
      aaa: {
        uid: localStorage.getItem("id"),
        Uids: "",
        xid: localStorage.getItem("xid"),
        type: "",
        ids: "null",
        qid: localStorage.getItem("pid"),
      },
      documentIsShow: false,
      iframeUrl: "",
      typeOptions: [
        { value: "", label: "全部" },
        { value: 0, label: "审核中" },
        { value: 1, label: "待审核" },
      ],
      rejectFileFlow: false,
      content: "",
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    rejectFileFlowOpen(type, data) {
      if (type == "single") {
        this.fileMultipleSelection.push(data);
      }
      if (this.baseNotity()) {
        return;
      }
      this.rejectFileFlow = true;
    },
    checkboxT(row) {
      if (row.isNeedAudit == 0) {
        return false;
      } else {
        return true;
      }
    },
    async FileBatchAudit(ispass, type, data) {
      if (type !== "single") {
        if (this.baseNotity()) {
          return;
        }
      }
      let ids = [];
      if (type == "single") {
        ids = [data.prfl01];
      } else {
        ids = this.fileMultipleSelection.reduce((a, b) => {
          a.push(b.prfl01);
          return a;
        }, []);
      }
      let params = {
        ids,
        ispass,
        content: this.content,
        uid: localStorage.id,
      };

      let res = await FileBatchAudit(params);
      if (res.Code) {
        this.getDataFileList();
        if (ispass == 0) {
          this.$message({
            type: "success",
            message: "已驳回",
          });
          this.rejectFileFlow = false;
        } else {
          this.$message({
            type: "success",
            message: "已通过",
          });
        }
      }
    },
    baseNotity() {
      if (this.fileMultipleSelection.length == 0) {
        this.$message({
          message: "请选勾选报审资料",
          type: "warning",
        });
        return true;
      }
    },
    // 💩⛰️
    async documentOpen(item) {
      this.documentIsShow = true;
      if (
        item.ext == "pdf" ||
        item.ext == "png" ||
        item.ext == "jpg" ||
        item.ext == "mp4" ||
        item.ext == "gif" ||
        item.ext == "txt"
      ) {
        this.iframeUrl = this.$store.state.baseUrl + item.prfl04;
      } else {
        let res = await Office2Pdf({ sourcePath: item.prfl04 });
        if (res.Code === 0) {
          this.$message({
            type: "warning",
            message: res.Message,
          });
        } else {
          this.iframeUrl = this.$store.state.baseUrl + res.Data;
        }
      }
    },
    //下载
    download(data) {
      tools.download(data.prfl07, data.prfl02);
    },
    // 初始化数据
    getData() {
      let params = {
        xid: localStorage.getItem("xid"),
      };
      GetProjectFileZTree({ params }).then((res) => {
        this.TreeData = res.Data;
        this.init();
      });
    },
    // 获取我的文件
    getDataFileList() {
      let params = {
        searchword: this.query,
        xid: localStorage.getItem("xid"),
        uid: localStorage.getItem("id"),
        gid: this.aaa.ids,
        type: this.aaa.type,
        pageIndex: this.pagenum,
        pageSize: this.pagesize,
      };
      this.tableLoading = true;
      GetMyAuditFile({ params }).then((res) => {
        this.tableLoading = false;
        this.total = res.Data.total;
        this.fileTableData = res.Data.list;
        this.fileTableData2 = _.cloneDeep(res.Data.list);
        if (this.fileTableData) {
          this.fileTableData.forEach((v) => {
            v.ext = v.prfl03
              .substring(v.prfl03.lastIndexOf(".") + 1)
              .toLowerCase();
          });
        }
      });
    },
    selectChange(data) {
      if (data == 0 || data == 1) {
        this.fileTableData = this.fileTableData2.filter(
          (ele) => ele.isNeedAudit == data
        );
      } else {
        this.fileTableData = this.fileTableData2;
      }
    },
    // 显示全部
    showAll() {
      this.aaa.ids = "null";
      this.getDataFileList();
    },
    //初始化ztree
    init() {
      var _this = this;

      var setting = {
        view: {
          selectedMulti: false,
        },
        check: {
          enable: true,
        },
        data: {
          key: {
            name: "pftr02",
          },
          simpleData: {
            enable: true,
            idKey: "pftr01",
            pIdKey: "pftr03",
          },
        },
        callback: {
          onCheck: onCheck,
          onClick: onclick,
        },
      };
      this.zTeeObj = $.fn.zTree.init(
        $("#ProjectFileTree"),
        setting,
        this.TreeData
      );
      this.zTeeObj.checkAllNodes(true);
      var checkedNodes = this.zTeeObj.getCheckedNodes();
      _this.aaa.ids = "";
      var _split = "";
      checkedNodes.forEach((element) => {
        _this.aaa.ids += _split + element.pftr01;
        _split = ",";
      });
      _this.getDataFileList();
      // 选中状态
      function onCheck() {
        var checkedNodes = _this.zTeeObj.getCheckedNodes();
        _this.aaa.ids = "";
        var _split = "";
        checkedNodes.forEach((element) => {
          _this.aaa.ids += _split + element.pftr01;
          _split = ",";
        });
        _this.getDataFileList();
      }
      //点击事件
      function onclick(event, treeId, treeNode) {
        _this.aaa.ids = treeNode.pftr01;
        _this.getDataFileList();
      }
    },
    fileFlowhandleSelectionChange(val) {
      this.fileMultipleSelection = val;
    },
    handleSizeChange(val) {
      this.pagesize = val;
      this.getDataFileList();
    },
    handleCurrentChange(val) {
      this.pagenum = val;
      this.getDataFileList();
    },
  },
};
</script>

<style lang="less" scoped>
div#dataListRemenu {
  position: fixed;
  visibility: hidden;
  top: 0;
  width: 60px;
  background-color: #35a5db;
  padding: 4px;
  border-radius: 3px;
  overflow: auto;
  border: 1px solid #eee;
}

div#dataListRemenu ul {
  margin: 0px;
  padding: 0px;
}

div#dataListRemenu ul li {
  font-size: 12px;
  line-height: 20px;
  margin: 0px;
  padding: 0px;
  cursor: pointer;
  list-style: none outside none; //取消样式
  background-color: rgba(255, 255, 255, 0);
  padding-left: 3px;
  margin: 1px auto;
  color: white;
  border-radius: 3px;
  letter-spacing: 1px;
}

div#dataListRemenu ul li:hover {
  background: #eee;
  color: #000000;
}
#ProjectFileTree {
  height: 500px;
}
.zTreeDiv {
  overflow: auto;
}
.ztree li span {
  line-height: 21px;
  margin-right: 2px;
}
.userManagement .search-input {
  width: 300px;
}
</style>
